import { catchError, map, of, switchMap, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Resource } from './resource';
import { ApiParams } from './api-params';
import { LoggerService } from '@content-platform/web-angular-shared-util-logging';
import { MOCK_APPLICATION_ACCESS_LIST, USE_MOCK_DATA_ON_ERROR } from './mock-data';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "@content-platform/web-angular-shared-util-logging";
import * as i3 from "./api-params";
export class ApplicationResource extends Resource {
    constructor(http, logger, apiParams) {
        super(http, logger.instance('ApplicationResource'));
        this.apiParams = apiParams;
    }
    getUrl() {
        return this.apiParams.getUrl('applications');
    }
    /**
     * Only sends the api supported data for the application.
     *
     * @param application
     * @returns parsed application
     */
    transformRequest(application) {
        const { id, features, name, deletedFeatures, lastModifiedBy, createdBy, hidden, url, imgUrl, imgUrlLrg, external, comingSoon, color, global } = application;
        return {
            id,
            features,
            name,
            deletedFeatures,
            lastModifiedBy,
            createdBy,
            hidden,
            url,
            imgUrl,
            imgUrlLrg,
            external,
            comingSoon,
            color,
            global
        };
    }
    get entityName() {
        return 'Application';
    }
    query(params) {
        return this.apiParams.getUrlAsync('applications').pipe(switchMap((url) => this.http
            .get(url, { headers: this.getHeaders(), params: params })
            .pipe(map((data) => this.transformResponse(data)), catchError((error) => USE_MOCK_DATA_ON_ERROR ? of(MOCK_APPLICATION_ACCESS_LIST) : throwError(error)))));
    }
    queryById(id) {
        return this.apiParams.getUrlAsync('applications').pipe(switchMap((url) => this.http
            .get(`${url}/${id}`, { headers: this.getHeaders() })
            .pipe(map((data) => data), catchError((error) => USE_MOCK_DATA_ON_ERROR ? of(MOCK_APPLICATION_ACCESS_LIST) : throwError(error)))));
    }
    static { this.ɵfac = function ApplicationResource_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ApplicationResource)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.LoggerService), i0.ɵɵinject(i3.ApiParams)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ApplicationResource, factory: ApplicationResource.ɵfac }); }
}
//# sourceMappingURL=application-resource.js.map